import apiService from './ApiService';

class AdminDashboardService {
  async getDashboard(regionalId) {
    if (!regionalId) {
      throw new Error('No hay regional seleccionado para cargar el dashboard.');
    }

    const response = await apiService.get(`/admindashboard/${regionalId}`);

    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos cargar el dashboard.';
      throw new Error(msg);
    }

    return response;
  }
}

const adminDashboardService = new AdminDashboardService();

export default adminDashboardService;
